import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { IDefectActWorkGuarantee } from './interfaces';

export const getDefectActWorkGuaranteeList = (data: IDynamicTableParams) => {
  return instance()
    .post<IDefectActWorkGuarantee[]>('/defectActWorkGuarantee/list', data)
    .then((response) => response.data);
};

export const getDefectActWorkGuaranteeListAll = () => {
  return instance()
    .post<IDefectActWorkGuarantee[]>('/defectActWorkGuarantee/listAll')
    .then((response) => response.data);
};

export const getDefectActWorkGuaranteeListAllNotDeleted = () => {
  return instance()
    .get<IDefectActWorkGuarantee[]>('/defectActWorkGuarantee/listAllNotDeleted')
    .then((response) => response.data);
};

export const getDefectActWorkGuaranteeAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>('/defectActWorkGuarantee/availableColumns')
    .then((response) => response.data);
};

export const getDefectActWorkGuaranteeAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>('/defectActWorkGuarantee/availableGroupColumns')
    .then((response) => response.data);
};

export const loadDefectActWorkGuarantee = (defectActWorkGuaranteeId: number) => {
  return instance()
    .get<IDefectActWorkGuarantee>(`/defectActWorkGuarantee/load/${defectActWorkGuaranteeId}`)
    .then((response) => response.data);
};

export const createDefectActWorkGuarantee = (defectActWorkGuarantee: IDefectActWorkGuarantee) => {
  return instance()
    .post<IDefectActWorkGuarantee>(`/defectActWorkGuarantee/save`, defectActWorkGuarantee)
    .then((response) => response.data);
};

export const updateDefectActWorkGuarantee = (
  defectActWorkGuaranteeId: number,
  defectActWorkGuarantee: IDefectActWorkGuarantee,
) => {
  return instance()
    .post<IDefectActWorkGuarantee>(`/defectActWorkGuarantee/update/${defectActWorkGuaranteeId}`, defectActWorkGuarantee)
    .then((response) => response.data);
};

export const archiveDefectActWorkGuarantee = (defectActWorkGuaranteeId: number) => {
  return instance()
    .post(`/defectActWorkGuarantee/archive/${defectActWorkGuaranteeId}`)
    .then((response) => response.data);
};

export const recoverDefectActWorkGuarantee = (defectActWorkGuaranteeId: number) => {
  return instance()
    .post(`/defectActWorkGuarantee/recover/${defectActWorkGuaranteeId}`)
    .then((response) => response.data);
};
